import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _7fbff3c6 = () => interopDefault(import('../src/pages/companies/index.vue' /* webpackChunkName: "pages/companies/index" */))
const _2a099092 = () => interopDefault(import('../src/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _6ca6568f = () => interopDefault(import('../src/pages/sign_in.vue' /* webpackChunkName: "pages/sign_in" */))
const _e345ff2c = () => interopDefault(import('../src/pages/google-calendar/callback.vue' /* webpackChunkName: "pages/google-calendar/callback" */))
const _d1be4444 = () => interopDefault(import('../src/pages/initial-settings/company-profile.vue' /* webpackChunkName: "pages/initial-settings/company-profile" */))
const _63ff0540 = () => interopDefault(import('../src/pages/initial-settings/invite-members.vue' /* webpackChunkName: "pages/initial-settings/invite-members" */))
const _320b4072 = () => interopDefault(import('../src/pages/initial-settings/user-profile.vue' /* webpackChunkName: "pages/initial-settings/user-profile" */))
const _628bd839 = () => interopDefault(import('../src/pages/sessions/branu-logout.vue' /* webpackChunkName: "pages/sessions/branu-logout" */))
const _d03865c2 = () => interopDefault(import('../src/pages/sessions/callback.vue' /* webpackChunkName: "pages/sessions/callback" */))
const _4caef699 = () => interopDefault(import('../src/pages/sessions/callback-with-branu-user.vue' /* webpackChunkName: "pages/sessions/callback-with-branu-user" */))
const _3bed31f3 = () => interopDefault(import('../src/pages/sessions/invitation.vue' /* webpackChunkName: "pages/sessions/invitation" */))
const _114517b0 = () => interopDefault(import('../src/pages/contents/_uuid/index.vue' /* webpackChunkName: "pages/contents/_uuid/index" */))
const _4d69c452 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds" */))
const _343d243a = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds/new.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds/new" */))
const _421cbeb6 = () => interopDefault(import('../src/pages/companies/_company_id/customers.vue' /* webpackChunkName: "pages/companies/_company_id/customers" */))
const _0beed372 = () => interopDefault(import('../src/pages/companies/_company_id/customers/new.vue' /* webpackChunkName: "pages/companies/_company_id/customers/new" */))
const _1286fb24 = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/index" */))
const _721733a8 = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/edit" */))
const _3429949e = () => interopDefault(import('../src/pages/companies/_company_id/expiration.vue' /* webpackChunkName: "pages/companies/_company_id/expiration" */))
const _da61f08c = () => interopDefault(import('../src/pages/companies/_company_id/members.vue' /* webpackChunkName: "pages/companies/_company_id/members" */))
const _49dc004a = () => interopDefault(import('../src/pages/companies/_company_id/profile.vue' /* webpackChunkName: "pages/companies/_company_id/profile" */))
const _374562ae = () => interopDefault(import('../src/pages/companies/_company_id/projects.vue' /* webpackChunkName: "pages/companies/_company_id/projects" */))
const _df171b28 = () => interopDefault(import('../src/pages/companies/_company_id/projects/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/index" */))
const _39417794 = () => interopDefault(import('../src/pages/companies/_company_id/projects/calendar.vue' /* webpackChunkName: "pages/companies/_company_id/projects/calendar" */))
const _90c321fc = () => interopDefault(import('../src/pages/companies/_company_id/projects/gantt-chart/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/gantt-chart/index" */))
const _68c9f4ba = () => interopDefault(import('../src/pages/companies/_company_id/projects/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/new" */))
const _3c1ef35c = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/index" */))
const _59bc8cb9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/devices-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/devices-allocation/index" */))
const _58bef9c0 = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/member-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/member-allocation/index" */))
const _55141fd4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id" */))
const _0c931152 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/index" */))
const _77c53fb7 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/index" */))
const _83c5ed7c = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/index" */))
const _f946f544 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/card/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/card/index" */))
const _5528f9c8 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/detail.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/detail" */))
const _7980ae36 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/member.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/member" */))
const _50e76e07 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/index" */))
const _b34d62b6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/index" */))
const _433b154b = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/summary.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/summary" */))
const _32af8276 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-list.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-list" */))
const _23a746eb = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-records.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-records" */))
const _32aeb422 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils" */))
const _6f147884 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils/user-list.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils/user-list" */))
const _7f936de0 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/new" */))
const _c1d347f4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/posts/index" */))
const _b19b9956 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/select-daily-reports.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/select-daily-reports" */))
const _5ccdcd10 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/fullscreen" */))
const _172a7bdb = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/preview" */))
const _aeec8cfa = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/print/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/print/index" */))
const _98f7cfb6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/index" */))
const _47303ff8 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/fullscreen" */))
const _70916ea6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/index" */))
const _57543036 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/index" */))
const _330f47e6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/edit" */))
const _6317680e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index" */))
const _36472ac7 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/edit" */))
const _8f3475ca = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/preview" */))
const _63ab9741 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/form.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/form" */))
const _c2f5db4a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/preview" */))
const _0f72cbe3 = () => interopDefault(import('../src/pages/companies/_company_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/index" */))
const _37fbd971 = () => interopDefault(import('../src/pages/companies/_company_id/setting.vue' /* webpackChunkName: "pages/companies/_company_id/setting" */))
const _28e1c2c6 = () => interopDefault(import('../src/pages/companies/_company_id/sharing-contents/index.vue' /* webpackChunkName: "pages/companies/_company_id/sharing-contents/index" */))
const _4c46139c = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/index" */))
const _5bf3a263 = () => interopDefault(import('../src/pages/companies/_company_id/unavailability.vue' /* webpackChunkName: "pages/companies/_company_id/unavailability" */))
const _7241dc54 = () => interopDefault(import('../src/pages/companies/_company_id/user-profile.vue' /* webpackChunkName: "pages/companies/_company_id/user-profile" */))
const _1e1f0ce9 = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/analytics/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/analytics/index" */))
const _9ef07b74 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/index" */))
const _93258564 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/index" */))
const _206a0474 = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/_member_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/_member_id/index" */))
const _77300046 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/edit" */))
const _4f8a8b3c = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/preview" */))
const _a22a31e2 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/ai_pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/ai_pdf" */))
const _bea9f784 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/edit" */))
const _32041e6e = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/pdf" */))
const _79cdc294 = () => interopDefault(import('../src/pages/companies/_company_id/project/_id/schedule/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/project/_id/schedule/pdf" */))
const _353716fa = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'

    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto'
    })

    // Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual'
    })
  }
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected and scrollToTop is not explicitly disabled
  if (
    to.matched.length < 2 &&
    to.matched.every(r => r.components.default.options.scrollToTop !== false)
  ) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise((resolve) => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/companies",
      component: _7fbff3c6,
      name: "companies"
    }, {
      path: "/logout",
      component: _2a099092,
      name: "logout"
    }, {
      path: "/sign_in",
      component: _6ca6568f,
      name: "sign_in"
    }, {
      path: "/google-calendar/callback",
      component: _e345ff2c,
      name: "google-calendar-callback"
    }, {
      path: "/initial-settings/company-profile",
      component: _d1be4444,
      name: "initial-settings-company-profile"
    }, {
      path: "/initial-settings/invite-members",
      component: _63ff0540,
      name: "initial-settings-invite-members"
    }, {
      path: "/initial-settings/user-profile",
      component: _320b4072,
      name: "initial-settings-user-profile"
    }, {
      path: "/sessions/branu-logout",
      component: _628bd839,
      name: "sessions-branu-logout"
    }, {
      path: "/sessions/callback",
      component: _d03865c2,
      name: "sessions-callback"
    }, {
      path: "/sessions/callback-with-branu-user",
      component: _4caef699,
      name: "sessions-callback-with-branu-user"
    }, {
      path: "/sessions/invitation",
      component: _3bed31f3,
      name: "sessions-invitation"
    }, {
      path: "/contents/:uuid?",
      component: _114517b0,
      name: "contents-uuid"
    }, {
      path: "/companies/:company_id/construction-kinds",
      component: _4d69c452,
      name: "companies-company_id-construction-kinds",
      children: [{
        path: "new",
        component: _343d243a,
        name: "companies-company_id-construction-kinds-new"
      }]
    }, {
      path: "/companies/:company_id/customers",
      component: _421cbeb6,
      name: "companies-company_id-customers",
      children: [{
        path: "new",
        component: _0beed372,
        name: "companies-company_id-customers-new"
      }, {
        path: ":id",
        component: _1286fb24,
        name: "companies-company_id-customers-id"
      }, {
        path: ":id/edit",
        component: _721733a8,
        name: "companies-company_id-customers-id-edit"
      }]
    }, {
      path: "/companies/:company_id/expiration",
      component: _3429949e,
      name: "companies-company_id-expiration"
    }, {
      path: "/companies/:company_id/members",
      component: _da61f08c,
      name: "companies-company_id-members"
    }, {
      path: "/companies/:company_id/profile",
      component: _49dc004a,
      name: "companies-company_id-profile"
    }, {
      path: "/companies/:company_id/projects",
      component: _374562ae,
      children: [{
        path: "",
        component: _df171b28,
        name: "companies-company_id-projects"
      }, {
        path: "calendar",
        component: _39417794,
        name: "companies-company_id-projects-calendar"
      }, {
        path: "gantt-chart",
        component: _90c321fc,
        name: "companies-company_id-projects-gantt-chart"
      }, {
        path: "new",
        component: _68c9f4ba,
        name: "companies-company_id-projects-new"
      }, {
        path: "resource-allocation",
        component: _3c1ef35c,
        name: "companies-company_id-projects-resource-allocation"
      }, {
        path: "resource-allocation/devices-allocation",
        component: _59bc8cb9,
        name: "companies-company_id-projects-resource-allocation-devices-allocation"
      }, {
        path: "resource-allocation/member-allocation",
        component: _58bef9c0,
        name: "companies-company_id-projects-resource-allocation-member-allocation"
      }, {
        path: ":id",
        component: _55141fd4,
        children: [{
          path: "",
          component: _0c931152,
          name: "companies-company_id-projects-id"
        }, {
          path: "attendance",
          component: _77c53fb7,
          name: "companies-company_id-projects-id-attendance"
        }, {
          path: "board_posts",
          component: _83c5ed7c,
          name: "companies-company_id-projects-id-board_posts"
        }, {
          path: "card",
          component: _f946f544,
          name: "companies-company_id-projects-id-card"
        }, {
          path: "detail",
          component: _5528f9c8,
          name: "companies-company_id-projects-id-detail"
        }, {
          path: "member",
          component: _7980ae36,
          name: "companies-company_id-projects-id-member"
        }, {
          path: "reports",
          component: _50e76e07,
          name: "companies-company_id-projects-id-reports"
        }, {
          path: "schedule",
          component: _b34d62b6,
          name: "companies-company_id-projects-id-schedule"
        }, {
          path: "attendance/summary",
          component: _433b154b,
          name: "companies-company_id-projects-id-attendance-summary"
        }, {
          path: "attendance/user-list",
          component: _32af8276,
          name: "companies-company_id-projects-id-attendance-user-list"
        }, {
          path: "attendance/user-records",
          component: _23a746eb,
          name: "companies-company_id-projects-id-attendance-user-records"
        }, {
          path: "attendance/utils",
          component: _32aeb422,
          name: "companies-company_id-projects-id-attendance-utils",
          children: [{
            path: "user-list",
            component: _6f147884,
            name: "companies-company_id-projects-id-attendance-utils-user-list"
          }]
        }, {
          path: "board_posts/new",
          component: _7f936de0,
          name: "companies-company_id-projects-id-board_posts-new"
        }, {
          path: "board_posts/posts",
          component: _c1d347f4,
          name: "companies-company_id-projects-id-board_posts-posts"
        }, {
          path: "reports/select-daily-reports",
          component: _b19b9956,
          name: "companies-company_id-projects-id-reports-select-daily-reports"
        }, {
          path: "schedule/fullscreen",
          component: _5ccdcd10,
          name: "companies-company_id-projects-id-schedule-fullscreen"
        }, {
          path: "schedule/preview",
          component: _172a7bdb,
          name: "companies-company_id-projects-id-schedule-preview"
        }, {
          path: "schedule/print",
          component: _aeec8cfa,
          name: "companies-company_id-projects-id-schedule-print"
        }, {
          path: "schedule/view",
          component: _98f7cfb6,
          name: "companies-company_id-projects-id-schedule-view"
        }, {
          path: "schedule/view/fullscreen",
          component: _47303ff8,
          name: "companies-company_id-projects-id-schedule-view-fullscreen"
        }, {
          path: "board_posts/:board_id",
          component: _70916ea6,
          name: "companies-company_id-projects-id-board_posts-board_id"
        }, {
          path: "files/:file_id",
          component: _57543036,
          name: "companies-company_id-projects-id-files-file_id"
        }, {
          path: "board_posts/:board_id/edit",
          component: _330f47e6,
          name: "companies-company_id-projects-id-board_posts-board_id-edit"
        }, {
          path: "board_posts/:board_id/files",
          component: _6317680e,
          name: "companies-company_id-projects-id-board_posts-board_id-files"
        }, {
          path: "files/:file_id/edit",
          component: _36472ac7,
          name: "companies-company_id-projects-id-files-file_id-edit"
        }, {
          path: "files/:file_id/preview",
          component: _8f3475ca,
          name: "companies-company_id-projects-id-files-file_id-preview"
        }, {
          path: "reports/:report_id/form",
          component: _63ab9741,
          name: "companies-company_id-projects-id-reports-report_id-form"
        }, {
          path: "reports/:report_id/preview",
          component: _c2f5db4a,
          name: "companies-company_id-projects-id-reports-report_id-preview"
        }]
      }]
    }, {
      path: "/companies/:company_id/reports",
      component: _0f72cbe3,
      name: "companies-company_id-reports"
    }, {
      path: "/companies/:company_id/setting",
      component: _37fbd971,
      name: "companies-company_id-setting"
    }, {
      path: "/companies/:company_id/sharing-contents",
      component: _28e1c2c6,
      name: "companies-company_id-sharing-contents"
    }, {
      path: "/companies/:company_id/skills-register",
      component: _4c46139c,
      name: "companies-company_id-skills-register"
    }, {
      path: "/companies/:company_id/unavailability",
      component: _5bf3a263,
      name: "companies-company_id-unavailability"
    }, {
      path: "/companies/:company_id/user-profile",
      component: _7241dc54,
      name: "companies-company_id-user-profile"
    }, {
      path: "/companies/:company_id/skills-register/analytics",
      component: _1e1f0ce9,
      name: "companies-company_id-skills-register-analytics"
    }, {
      path: "/companies/:company_id/files/:id?",
      component: _9ef07b74,
      name: "companies-company_id-files-id"
    }, {
      path: "/companies/:company_id/reports/:id",
      component: _93258564,
      name: "companies-company_id-reports-id"
    }, {
      path: "/companies/:company_id/skills-register/:member_id?",
      component: _206a0474,
      name: "companies-company_id-skills-register-member_id"
    }, {
      path: "/companies/:company_id/files/:id?/edit",
      component: _77300046,
      name: "companies-company_id-files-id-edit"
    }, {
      path: "/companies/:company_id/files/:id?/preview",
      component: _4f8a8b3c,
      name: "companies-company_id-files-id-preview"
    }, {
      path: "/companies/:company_id/reports/:id/ai_pdf",
      component: _a22a31e2,
      name: "companies-company_id-reports-id-ai_pdf"
    }, {
      path: "/companies/:company_id/reports/:id/edit",
      component: _bea9f784,
      name: "companies-company_id-reports-id-edit"
    }, {
      path: "/companies/:company_id/reports/:id/pdf",
      component: _32041e6e,
      name: "companies-company_id-reports-id-pdf"
    }, {
      path: "/companies/:company_id/project/:id?/schedule/pdf",
      component: _79cdc294,
      name: "companies-company_id-project-id-schedule-pdf"
    }, {
      path: "/",
      component: _353716fa,
      name: "index"
    }],

    fallback: false
  })
}
